import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import CountryFlag from 'vue-country-flag'

require("babel-polyfill");

import Spcc from './Spcc.vue'
import Calculator from './Calculator.vue'
import Gooimeer from './Gooimeer.vue'
import Hoesch from './Hoesch.vue'
 


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './../css/animate.css'

Vue.use(BootstrapVue);
Vue.component('country-flag', CountryFlag)

Vue.component('Spcc', Spcc);
Vue.component('Gooimeer', Gooimeer);
Vue.component('Hoesch', Hoesch);
Vue.component('Calculator', Calculator);

const axios = require('axios');

new Vue({
  el: '#app',
})



// WEBPACK FOOTER //
// ./src/main.js